import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDContentContainer, FDHeadlineText, FDIcon, FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import TabGroup from 'Components/ComponentLibrary/Molecules/TabGroup/TabGroup';
import { DETAILS_TAB_QUERY_PARAM } from 'Views/Page/Content/Templates/WhatIfTemplate/Components/Sidebar/consts';
import RoadmapDeliverableInvestingDetailsPicker
  from './RoadmapDeliverableInvestingDetailsPicker/RoadmapDeliverableInvestingDetailsPicker';
import ScenarioSelectionAssumptionsPicker from './ScenarioSelectionAssumptionsPicker/ScenarioSelectionAssumptionsPicker';
import ScenarioSelectionDetailedSummaryPicker from './ScenarioSelectionDetailedSummaryPicker/ScenarioSelectionDetailedSummaryPicker';
import ScenarioSelectionChartsPicker from './ScenarioSelectionChartsPicker/ScenarioSelectionChartsPicker';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  const LAYOUTS = {
    [fr.relationships.assumptions.name]: (<FDContentContainer maxWidth="md"><ScenarioSelectionAssumptionsPicker resource={resource} /></FDContentContainer>),
    [fr.relationships.detailedSummary.name]: (<ScenarioSelectionDetailedSummaryPicker resource={resource} />),
    [fr.relationships.charts.name]: (<FDContentContainer maxWidth="md"><ScenarioSelectionChartsPicker resource={resource} /></FDContentContainer>),
    [fr.relationships.investingDetails.name]: (<FDContentContainer maxWidth="md"><RoadmapDeliverableInvestingDetailsPicker resource={resource} /></FDContentContainer>),
  };

  const url = new URL(resource.link('self').url());
  const search = new URLSearchParams(url.search);
  const currentTab = search.get(DETAILS_TAB_QUERY_PARAM);

  return (
    <>
      <FDContentContainer maxWidth="md">{/* Not a problem if this is different from what's below, this content is tiny, we're just ensuring it has the right padding */}
        <FDStack direction={'column'} alignItems={'center'} spacing={2}>
          <FDIcon icon={'fac'} />
          <FDHeadlineText value={resource.attr('title')} color={'textSecondary'} size={'lg'} />
        </FDStack>
      </FDContentContainer>
      <TabGroup resource={resource} layouts={LAYOUTS} selectedTab={currentTab} />
    </>
  );
};

export default Layout;
